module.exports = __webpack_public_path__ + "static/media/navidad3.c160aab2.jpg";